import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux'

import { SCORES } from 'Constants';

import ChartSCore from 'Component/chart/score'
import QaisTab from 'Component/stock/qais_tab';
import QaisScore from 'Component/stock/qais_score';
import QaisDetail from 'Component/stock/qais_detail';

import SubHead from 'Component/title/sub_head';
import renderingGuide from 'Component/title/guide_content';
import { formatFixed } from 'Util';

const Qais = () => {

  const { tickerDetail } = useSelector((state) => state.stock);

  const [data, setData] = useState();
  const [type, setType] = useState(SCORES[0]);
  const [score, setScore] = useState();
  const [title, setTitle] = useState();
  
  useEffect(() => {
    const list = [];
    if (tickerDetail && tickerDetail.qais) {
      list.push({
        name: tickerDetail.outline.WI26_NM,
        value: [formatFixed(tickerDetail.qais.SEC_GROWTH), formatFixed(tickerDetail.qais.SEC_PERFORMANCE), formatFixed(tickerDetail.qais.SEC_STABILITY), formatFixed(tickerDetail.qais.SEC_MOMENTUM), formatFixed(tickerDetail.qais.SEC_VALUE)]
      });
      list.push({
        name: tickerDetail.TICKER_NAME,
        value: [formatFixed(tickerDetail.qais.GROWTH), formatFixed(tickerDetail.qais.PERFORMANCE), formatFixed(tickerDetail.qais.STABILITY), formatFixed(tickerDetail.qais.MOMENTUM), formatFixed(tickerDetail.qais.VALUE)]
      });
      setData(list);
      if (tickerDetail.qais.GROWTH_STEP) {
        setType(SCORES[0]);
      } else if (tickerDetail.qais.VALUE_STEP) {
        setType(SCORES[1]);
      } else if (tickerDetail.qais.MOMENTUM_STEP) {
        setType(SCORES[2]);
      } else if (tickerDetail.qais.STABILITY_STEP) {
        setType(SCORES[3]);
      } else if (tickerDetail.qais.PERFORMANCE_STEP) {
        setType(SCORES[4]);
      }
    } else {
      setData(null);
    }
  }, [tickerDetail])

  useEffect(() => {
    if (tickerDetail && type) {
      if (type.value === 'G') {
        setScore({
          SCORE1: tickerDetail.qais_detail.G_SCORE1,
          STEP1: tickerDetail.qais_detail.G_SCORE_STEP1,
          SCORE2: tickerDetail.qais_detail.G_SCORE2,
          STEP2: tickerDetail.qais_detail.G_SCORE_STEP2,
          SCORE3: tickerDetail.qais_detail.G_SCORE3,
          STEP3: tickerDetail.qais_detail.G_SCORE_STEP3,
        })
        setTitle(['순이익 증가율', '영업이익 증가율', '자기자본수익률 증가율']);
      } else if (type.value === 'V') {
        setScore({
          SCORE1: tickerDetail.qais_detail.V_SCORE1,
          STEP1: tickerDetail.qais_detail.V_SCORE_STEP1,
          SCORE2: tickerDetail.qais_detail.V_SCORE2,
          STEP2: tickerDetail.qais_detail.V_SCORE_STEP2,
          SCORE3: tickerDetail.qais_detail.V_SCORE3,
          STEP3: tickerDetail.qais_detail.V_SCORE_STEP3,
        })
        setTitle(['절대수익모델(RIM)', '주가수익비율(PER)', '주가순자산비율(PBR)']);
      } else if (type.value === 'M') {
        setScore({
          SCORE1: tickerDetail.qais_detail.M_SCORE1,
          STEP1: tickerDetail.qais_detail.M_SCORE_STEP1,
          SCORE2: tickerDetail.qais_detail.M_SCORE2,
          STEP2: tickerDetail.qais_detail.M_SCORE_STEP2,
          SCORE3: tickerDetail.qais_detail.M_SCORE3,
          STEP3: tickerDetail.qais_detail.M_SCORE_STEP3,
        })
        setTitle(['모멘텀', '모멘텀', '모멘텀']);
      } else if (type.value === 'S') {
        setScore({
          SCORE1: tickerDetail.qais_detail.S_SCORE1,
          STEP1: tickerDetail.qais_detail.S_SCORE_STEP1,
          SCORE2: tickerDetail.qais_detail.S_SCORE2,
          STEP2: tickerDetail.qais_detail.S_SCORE_STEP2,
          SCORE3: tickerDetail.qais_detail.S_SCORE3,
          STEP3: tickerDetail.qais_detail.S_SCORE_STEP3,
        })
        setTitle(['부채비율', '유동비율', '자기자본비율']);        
      } else if (type.value === 'P') {
        setScore({
          SCORE1: tickerDetail.qais_detail.P_SCORE1,
          STEP1: tickerDetail.qais_detail.P_SCORE_STEP1,
          SCORE2: tickerDetail.qais_detail.P_SCORE2,
          STEP2: tickerDetail.qais_detail.P_SCORE_STEP2,
          SCORE3: tickerDetail.qais_detail.P_SCORE3,
          STEP3: tickerDetail.qais_detail.P_SCORE_STEP3,
        })
        setTitle(['자기자본수익률', '매출액', '영업이익']);        
      }
    }
  }, [tickerDetail, type])

  function changeType(val) {
    setType(val);
  }

	return (
    <div className="content9">
      <SubHead guideType="stock" guide="qais">
        <img src="/static/images/icon_certify2.png" alt="" />
        <span>토브스탁 기업분석 점수</span>
      </SubHead>
      { data &&
        <div className="cont">
          <ChartSCore data={data} />
        </div>
      }

      { tickerDetail &&
        <QaisScore data={tickerDetail} />
      }

      <div className="detail tabarea">
        { tickerDetail && tickerDetail.qais &&
          <QaisTab data={tickerDetail.qais} menus={SCORES} selected={type} changeMenu={changeType} />
        }
        { score &&
          <QaisDetail data={score} title={title} />
        }
      </div>
    </div>
  );
}

export default Qais;
